import { render, staticRenderFns } from "./assets.vue?vue&type=template&id=0cd9a06e&scoped=true"
import script from "./assets.vue?vue&type=script&lang=js"
export * from "./assets.vue?vue&type=script&lang=js"
import style0 from "./assets.vue?vue&type=style&index=0&id=0cd9a06e&prod&scoped=true&lang=css"
import style1 from "./assets.vue?vue&type=style&index=1&id=0cd9a06e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd9a06e",
  null
  
)

export default component.exports